<template>

    <div class="container-fluid">

        <div class="page-heading mb-4">
            <p class="page-eyebrow">SPEAKER DIRECTORY</p>
            <h1 class="h3 mb-1 text-gray-800">Speakers</h1>
            <p class="mb-0 text-muted">Search, review, and manage speaker profiles in one place.</p>
        </div>

        <SpeakerList></SpeakerList>
    </div>

</template>

<script>
import {defineComponent} from 'vue'
import SpeakerList from "@/components/master/SpeakerList.vue";

export default defineComponent({
    name: "SpeakerPage",
    components: {
        SpeakerList
    }
})
</script>


<style scoped>
.page-heading {
    border-bottom: 1px solid #e2e6ea;
    padding-bottom: 1rem;
}

.page-eyebrow {
    color: #426cc6;
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    margin: 0 0 0.35rem;
}
</style>
